/* eslint-disable comma-dangle */
import { getTime } from '@type.engineering/type-engineer'
import { getMonth } from '../../../../maurice/components/tableu/lib-js'
import { DAYS_OF_WEEK, DAY_HEADINGS, FULL_DAY_HEADINGS, NIGHT_HEADINGS } from '../../lib'
import BookingColumnController from '../booking-column/BookingColumnController'
import CalendarController from '../calendar/CalendarComponent'
// import CalendarController from '../calendar/CalendarController'
import CalendarHeadingController from '../calendar/CalendarHeadingController'
import { LoginFormController } from '../login-form/LoginFormComponent'
import PlannerController from '../planner/PlannerComponent'
import { SignupFormController } from '../signup-form/SignupFormComponent'
import BookingController from './BookingController'
import { getApplicableDays } from './lib'

export default class BookingComponent {
 render(props) {
  const{el}=this
  const CSS = props.splendid.css('booking.js')
  BookingController.control(el, {
   props,
   classes: {
    SwitchSelected: CSS`SwitchSelected`,
   }
  })
 }
 constructor(el) {
  this.el = el
 }
}
BookingComponent['plain'] = true

/** @constructor @extends {BookingController} @suppress {checkTypes} */ function _BookingController() {}
BookingController.__implement(
 _BookingController.prototype = /** @type {!BookingController} */ ({
  paint() {
   const{
    asIDateRanger:{dateRange:{asIDateRange:{formatDate},StartDate:SD,startHours}},
    StartDate,
   }=this
   if (!SD) StartDate.innerHTML='выберите дату'
   else StartDate.innerHTML=formatDate(SD,startHours!=null)
  },
 }),
 _BookingController.prototype = /** @type {!BookingController} */ ({
  paint() {
   const{
    asIDateRanger:{dateRange:{asIDateRange:{formatDate},EndDate:ED,endHours}},
    EndDate,
   }=this
   if (!ED)EndDate.innerHTML='выберите дату'
   else EndDate.innerHTML=formatDate(ED,endHours!=null)
  },
  // selectNextMonth() {
  //   console.log(123)
  // },
  // selectPrevMonth() {
  //   console.log(123)
  // }
 }),
 _BookingController.prototype = /** @type {!BookingController} */ ({
  privacyChange() {
   const{PrivacyCheckbox:{checked},asIBookingController:{setState}}=this
   setState({privacy_accepted:checked})
  },
  __$constructor() {
   const{
    BookingColumn,Calendar,Planner,
    asIBookingController:{availabilityLoader,bookingLoader,setState,state},
    asIDateRanger:{dateRange},
    asITariffLoaderer:{tariffLoader},
    asIUserLoaderer:{userLoader},
    asIProper:{props:{month,year,splendid,HOST,bike_id}}}=this
   const{asIAvailabilityLoader:{
    GetAvailability:GetAvailability
   }}=availabilityLoader

   // const time = getTime()
   // console.log(time)

   const prevMonthBu=this.element.querySelector('[data-id="PrevMonthBu"]')
   const nextMonthBu=this.element.querySelector('[data-id="NextMonthBu"]')

   const updCal=(newMonth)=>{
    let newYear
    if(newMonth>11) {
     newMonth=0
     newYear=Calendar.state.year+1
    }else if(newMonth<0) {
     newMonth=11
     newYear=Calendar.state.year-1
    }
    Calendar.setState({
     month:newMonth,
     ...(newYear?{year:newYear}:{}),
    })
    Calendar.reinitCellField()
    GetAvailability({
     month: newMonth,
     year:   newYear||Calendar.year,
    })
    const isThisMonth=
          Calendar.today.getMonth()==Calendar.state.month&&
          Calendar.today.getFullYear()==Calendar.state.year
    if(isThisMonth) {
     prevMonthBu.style['visibility']='hidden'
    } else {
     prevMonthBu.style['visibility']=''
    }
    this.Calendar.CalendarHeading.innerHTML=`${getMonth(Calendar.state.month)} ${Calendar.state.year}`
   }
   nextMonthBu.addEventListener('click',()=>{
    const newMonth=Calendar.state.month+1
    updCal(newMonth,true)
   })
   prevMonthBu.addEventListener('click',()=>{
    const newMonth=Calendar.state.month-1
    updCal(newMonth)
   })


   BookingColumnController.control(BookingColumn, {
    symbols: {
     _bookingState:state,
     _bookingLoader:bookingLoader,

     _tariffLoader:tariffLoader,
     _dateRange:dateRange,
     _userLoader:userLoader,
    },
    classes: {
     BottomGreenGradient:'BottomGreenGradient', // global app styles
     BottomRedGradient:'BottomRedGradient',
     BottomYellowGradient:'BottomYellowGradient',
     RemoveBackground:'RemoveBackground',
    },
   })
   const{SignupForm,LoginForm}=BookingColumn
   BookingColumn.addEventListener('booking', ({ booking_id }) => {
    GetAvailability({
     month: Calendar.month,year:Calendar.year,
    })
    setState({
     booking_id,
    })
    Calendar.setProps({
     disabled: true,
    })
   })

   // debugger // if controlling multiple times, stuff is broken.
   // but not when exported???
   SignupFormController.control(SignupForm, {
    symbols: {
     _userLoader: userLoader,
    },
   })
   LoginFormController.control(LoginForm, {
    symbols: {
     _userLoader: userLoader,
    }
   })

   CalendarController.control(Calendar, {
    symbols: {
     _availabilityLoader: availabilityLoader,
     _dateRange:dateRange,
    },
    props:{month,year,splendid},
    state:{month,year,},
   })

   window.addEventListener('signin',()=>{
    tariffLoader.fetchTariff()
   })
   window.addEventListener('signup',()=>{
    tariffLoader.fetchTariff()
   })
   window.addEventListener('signout',()=>{
    tariffLoader.fetchTariff()
   })
   setTimeout(() => { // those props will be ready when guest is updated for initialisers.
    availabilityLoader.props = bookingLoader.props = tariffLoader.props = {
     HOST,
     bike_id,
    }
    // debugger
    const isLocalhost=/localhost/.test(HOST)
    // const isLocalhost=false///localhost/.test(HOST)
    userLoader.props = {
     HOST:isLocalhost?HOST:'https://user.hulkmoto.ru',
     bike_id,
    }
    tariffLoader.fetchTariff()
    userLoader.GetUser()
    GetAvailability({
     month: Calendar.month,year:Calendar.year,
    })
   }, 1)

   const plannerController = PlannerController.control(Planner, {
    props:{splendid},
    state:{collapsed:true},
   })
   plannerController.setDerivedProps({
    /** @this {ru.hulkmoto.DateRange} */
    get title() {
     const{StartDate}=this
     if(!StartDate)return undefined
     return StartDate.toLocaleDateString('default')
    }
   },dateRange)
   this.plannerController=plannerController
   // plannerController

   // const time2 = getTime()
   // console.log(time2)
   // this.deps = [this.Calendar]
  },
  ready() {
   /** @type {!Array<!CalendarHeadingController>} */
   // const ths = [...this.Calendar.querySelectorAll('tr th')]
   const ths = [...this.querySelectorAll('tr th')]
   let i = 0
   for (const th of ths) {
    CalendarHeadingController.control(th, { props: { i } })
    th.setDerivedState({
     /** @this {BookingController} */
     get headings() {
      const {state:{currentTariff}}=this
      if (currentTariff=='day')return DAY_HEADINGS
      if (currentTariff=='twentyFourHours')return FULL_DAY_HEADINGS
      if (currentTariff=='night')return NIGHT_HEADINGS
      if (currentTariff=='fiveHours')return DAYS_OF_WEEK
      return null
     },
    }, this)
    i++
   }

   const{Calendar,dateRange,BookingColumn}=this
   BookingColumn.setDerivedState({
    /** @this {BookingController} */
    get discount() {
     const{
      state:{currentTariff},tariffLoader:{state:{
       twelveHourDiscount,twelveHourPrice,
       dailyPrice,dailyDiscount,nightlyPrice:nightlyPrice,
       fiveHourPrice:fiveHourPrice,
      }},
      dateRange:{state:{range,startDate,endDate}},
     }=this
     // let res=dailyDiscount
     // ''
     let res
     if(!(startDate||endDate)&&dailyDiscount) {
      res=dailyDiscount+'%'
      return res
     }else if(!startDate||!endDate) {
      return ''
     }

     if(currentTariff=='day'&&twelveHourDiscount){
      res='-'+twelveHourPrice*(twelveHourDiscount/100) // twelveHourDiscount + '%'
     }else if(currentTariff=='twentyFourHours'&&dailyDiscount) {
      if(range == 0) {
       res='-'+dailyPrice*(dailyDiscount/100)
      } else {
       const applicable=getApplicableDays(dateRange,startDate,endDate)
       const totalDiscount=applicable*dailyPrice*(dailyDiscount/100)
       res='-'+totalDiscount//totalDiscount?('-' + totalDiscount):'—'
      }
     } else if(currentTariff=='night') {
      res='-'+nightlyPrice*(dailyDiscount/100)
     } else if(currentTariff=='fiveHours') {
      res='-'+fiveHourPrice*(dailyDiscount/100)
     }
     else res = ''
     if(dailyDiscount)
      return `(${dailyDiscount}%) ` + res + ' руб.'

     return ''
    },
   }, this)
   dateRange.setDerivedState({
    /** @this {BookingController} */
    get startHours() {
     const{state:{currentTariff},Planner:{asICellFieldController:{start}}}=this
     let res
     if(currentTariff=='day')res=10
     else if(currentTariff== 'night')res=22
     else if(currentTariff=='twentyFourHours')res=start
     else if(currentTariff=='fiveHours')res=start
     return res
    },
    /** @this {BookingController} */
    get endHours() {
     const{state:{currentTariff},Planner:{asICellFieldController:{end,start}}}=this
     let res
     if (currentTariff=='day')res=22
     else if(currentTariff=='night')res=10
     else if(currentTariff=='twentyFourHours')res=start
     else if(currentTariff=='fiveHours')res=end!=null?end:null
     return res
    },
   },this)
   Calendar.setDerivedState({
    /** @this {BookingController} */
    get canSelectRange() {
     const{state:{currentTariff}}=this
     if (currentTariff=='twentyFourHours')return true
     return false
    },
    /** @this {BookingController} */
    get endNextDay() {
     const{state:{currentTariff}}=this
     if(currentTariff=='night')return true
     return false
    },
   },this) // multiple derived states
  },
 }),
)
